var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "expedient-global-vision-container" },
    [
      _c("ExpedientGlobalVisionTopBarComponent"),
      _c("ExpedientSummaryWidget"),
      _vm.hasAgendaPermission ? _c("ExpedientNextEventsWidget") : _vm._e(),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("ExpedientLastActionsWidget"),
          _c("ExpedientReminderNotesComponent"),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "row" },
        [
          _c("ExpedientActionsResumeWidget"),
          _c("ExpedientProfitabilityWidget"),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }